import { render, staticRenderFns } from "./redemptionlist.vue?vue&type=template&id=4ce19560&"
import script from "./redemptionlist.vue?vue&type=script&lang=js&"
export * from "./redemptionlist.vue?vue&type=script&lang=js&"
import style0 from "./redemptionlist.vue?vue&type=style&index=0&id=4ce19560&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports